import { createRouter, createWebHistory } from 'vue-router'
import Main from '../views/Main.vue'
import LoginScreen from '../views/LoginScreen.vue'
import AdminPanel from '../views/AdminPanel.vue'

const routes = [
  {
    path: '/app',
    name: 'Main',
    component: Main
  },
  {
    path: '/login',
    name: 'LoginScreen',
    component: LoginScreen
  },
  {
    path: '/admin',
    name: 'AdminPanel',
    component: AdminPanel
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
